import {
  transitionAccountLookup as transitionAccountLookupAPI,
  transitionGetSecurityQuestion as transitionGetSecurityQuestionAPI,
  transitionAnswerSecurityQuestion as transitionAnswerSecurityQuestionAPI,
  transitionGetProducts as transitionGetProductsAPI,
  transitionTransferProducts as transitionTransferProductsAPI,
  transitionConfirm as transitionConfirmAPI
} from '../Api';
import {scope} from '../settings';

const useTransition = handleApiCallWithToken => {
  const transitionAccountLookup = (...args) =>
    handleApiCallWithToken(transitionAccountLookupAPI, scope, ...args);

  const transitionGetSecurityQuestion = (...args) =>
    handleApiCallWithToken(transitionGetSecurityQuestionAPI, scope, ...args);

  const transitionAnswerSecurityQuestion = (...args) =>
    handleApiCallWithToken(transitionAnswerSecurityQuestionAPI, scope, ...args);

  const transitionGetProducts = (...args) =>
    handleApiCallWithToken(transitionGetProductsAPI, scope, ...args);

  const transitionTransferProducts = (...args) =>
    handleApiCallWithToken(transitionTransferProductsAPI, scope, ...args);

  const transitionConfirm = (...args) =>
    handleApiCallWithToken(transitionConfirmAPI, scope, ...args);

  return {
    transitionAccountLookup,
    transitionGetSecurityQuestion,
    transitionAnswerSecurityQuestion,
    transitionGetProducts,
    transitionTransferProducts,
    transitionConfirm
  };
};

export default useTransition;
